import request from "@/utils/request";

const giftApiList = [
  // 获取会议室预定信息
  [
    "getRecentMeeting",
    "GET",
    "/treasure/home/cloud/api/home/meeting/getRecentMeeting",
    "params"
  ],
  // 签到接口
  [
    "signIn",
    "GET",
    "/treasure/home/cloud/api/home/meeting/signInNumber",
    "params"
  ],
  // 获取版本详情
  ["getVersionDetail", "POST", "/treasure/version/detail"]
];

let apiListMap = giftApiList.reduce((sum, prev) => {
  if (!prev || !prev[0] || !prev[1]) return sum;
  sum[prev[0]] = prev;
  return sum;
}, {});

export function fetchData(apiName, payload) {
  const api = apiListMap[apiName];
  let options;
  if (api[4] === "replace" && payload) {
    options = {
      url: api[2].replace("{id}", payload),
      method: api[1]
    };
  } else {
    options = {
      url: api[2],
      method: api[1]
    };
  }
  if (api[1] === "GET" && api[4] !== "replace" && payload) {
    options.params = payload;
  }
  if (api[1] === "POST" && payload) {
    if (api[3] !== "params") {
      options.data = payload;
    } else {
      options.params = payload;
    }
  }
  return request(options);
}

export function getVersion(type) {
  return request({
    url: "/treasure/version/history",
    method: "POST",
    headers: {
      "T-CA-AppKey": type
    }
  });
}

// 审批操作
export function doNextRequest(data) {
  return request({
    url: '/treasure/bpm/doNext',
    method: 'POST',
    data
  })
}
